
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class UserAccountSection extends Vue {
  @Prop({ required: false })
    backUrl: string

  showBackButton = true

  setBackButtonVisibility(isVisible) {
    this.showBackButton = isVisible
  }

  back() {
    const guestPagesOnly = ['accounts-signup', 'accounts-reset-id-token']
    const referer: string = this.$routerClient.getReferrer()?.name || ''

    if (this.backUrl) {
      this.$router.push(this.backUrl)
    } else if (guestPagesOnly.includes(referer)) {
      this.$router.push('/')
    } else {
      this.$router.back()
    }
  }
}
